import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "../lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function PaymentStatus() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [detail, setDetail] = useState(null);
  const { refresh } = useAuth();

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setDetail(data);
        if (data.payment_status === "paid") {
          setStatus("paid");
          refresh();
          return;
        }
        if (data.status === "expired") { setStatus("expired"); return; }
        if (attempts >= 8) { setStatus("pending"); return; }
        setTimeout(poll, 2000);
      } catch {
        if (attempts >= 8) setStatus("error");
        else setTimeout(poll, 2000);
      }
    };
    poll();
  }, [sessionId, refresh]);

  return (
    <div data-testid="payment-status-page" className="min-h-screen flex items-center justify-center px-4 pt-20">
      <div className="tv-glass rounded-2xl p-10 w-full max-w-md text-center">
        {status === "checking" && (
          <>
            <Loader2 className="w-14 h-14 text-tv-brand animate-spin mx-auto" />
            <div className="mt-4 font-display text-2xl text-white">Confirming payment…</div>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="w-14 h-14 text-green-400 mx-auto" />
            <div className="mt-4 font-display font-black text-3xl text-white">You're in.</div>
            <div className="text-white/70 mt-2">Your subscription is active.</div>
            <Link to="/" data-testid="payment-home-btn" className="mt-6 inline-block bg-tv-accent text-black font-bold px-6 py-3 rounded-full">Start Watching</Link>
          </>
        )}
        {(status === "expired" || status === "error" || status === "pending") && (
          <>
            <XCircle className="w-14 h-14 text-red-400 mx-auto" />
            <div className="mt-4 font-display font-black text-3xl text-white">Payment {status}</div>
            <Link to="/subscribe" className="mt-6 inline-block bg-tv-accent text-black font-bold px-6 py-3 rounded-full">Try again</Link>
          </>
        )}
      </div>
    </div>
  );
}
